<script>
import picto_standard from '@/assets/img/picto/1_Standard_yellow.svg'
import picto_premium from '@/assets/img/picto/2_Premium_yellow.svg'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_yellow.svg'

export default {
  name: 'OfferIcon',
  props: {
    offer: {
      type: [String, Number],
      required: true
    },
    showName: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      picto_standard,
      picto_premium,
      picto_enterprise,
    }
  },
  computed: {
    picto() {
      switch (this.offer) {
        case '58':
        case 58:
          return { 
            svg: this.picto_enterprise, 
            name: window.V.$i18n.t('device.registrations.licence58')
          }
        case '43':
        case 43:
          return { 
            svg: this.picto_premium, 
            name: window.V.$i18n.t('device.registrations.licence43')

          }
        case '45':
        case 45:
          return { 
            svg: this.picto_standard, 
            name: window.V.$i18n.t('device.registrations.licence45')
          }
        default:
          return { svg: '', name: ''}
      }
    }
  },
  methods: {
  },
  created() {
  }
}
</script>

<template>
  <span class="OfferIcon" v-html="picto.svg" :title="picto.name" :aria-label="picto.name"></span>
</template>

<style lang="scss" scoped>
.OfferIcon {
  display: inline-block;
  width: 1em;
  line-height: 1;
}
</style>